import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import type { NavTab } from "@/types/navigation";

interface SidebarNavItemProps {
  icon: React.ReactNode;
  label: string;
  tab: NavTab;
  isActive: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}

export const SidebarNavItem = ({ icon, label, tab, isActive, onClick, children }: SidebarNavItemProps) => {
  const hasChildren = !!children;

  if (!hasChildren) {
    return (
      <button
        onClick={onClick}
        className={cn(
          "w-full flex items-center gap-2 py-1.5 text-xs rounded-md transition-colors",
          "pl-[28px]",
          isActive ? "bg-active text-primary font-medium" : "text-secondary hover:bg-hover hover:text-primary",
        )}
      >
        {icon}
        <span>{label}</span>
      </button>
    );
  }

  return (
    <Collapsible defaultOpen={isActive}>
      <div className="flex items-center">
        <CollapsibleTrigger className="group flex-shrink-0 w-[16px] ml-1 flex items-center justify-center text-tertiary hover:text-primary transition-colors">
          <ChevronDown className="w-3 h-3 transition-transform duration-200 group-data-[state=closed]:-rotate-90" />
        </CollapsibleTrigger>
        <button
          onClick={onClick}
          className={cn(
            "flex-1 flex items-center gap-2 px-2 py-1.5 text-xs rounded-md transition-colors",
            isActive ? "bg-active text-primary font-medium" : "text-secondary hover:bg-hover hover:text-primary",
          )}
        >
          {icon}
          <span>{label}</span>
        </button>
      </div>
      <CollapsibleContent className="pl-[28px]">{children}</CollapsibleContent>
    </Collapsible>
  );
};
